<template>
  <div>
    <div class="breadcrumbs mb-2">
      <v-breadcrumbs divider=">" :items="breadcrumbsList">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="{ name: item.path }"
            :disabled="item.disabled"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <PageTitle pageHeading="Service Hours" :rightsideButton="true">
      <v-btn
        dark
        class="font-weight-bold px-2"
        link
        :to="{ name: 'new-service-hour' }"
      >
        <span class="pl-2 pr-3"> New service hours </span>
      </v-btn>
    </PageTitle>

    <v-data-table
      :headers="headers"
      :items="serviceHours"
      :items-per-page="10"
      :options.sync="pagination"
      class="elevation-1 mt-8 service-list-table"
      :footer-props="{
        'items-per-page-options': [10, 25, 50, 75, 100],
      }"
      :server-items-length="totalItems"
      :loading="loading"
    >
      <template v-slot:[`item.name`]="{ item }">
        <router-link
          :to="{ name: 'view-service-hour', params: { id: item.id } }"
          class="body-1 word-break text-ellipsis cursor-pointer text-capitalize"
        >
          <span> {{ item.name }}</span></router-link
        >
      </template>

      <template v-slot:[`item.group_names`]="{ item }">
        <template v-for="(group, index) in item.group_names">
          <span :key="group" v-if="index < 2" class="">
            <span v-if="index !== 0">, </span>{{ group | upperCaseFirst }}
          </span>
        </template>
        <span v-if="item.group_names.length > 2" class="pl-2">
          + {{ item.group_names.length - 2 }}
        </span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <span @click.stop class="body-1">
          <v-menu left bottom offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon class="font-weight-bold">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense class="pa-0">
              <v-list-item-group>
                <v-list-item
                  id="edit-service-hours-link"
                  link
                  :to="{
                    name: 'edit-service-hour',
                    params: { id: item.id },
                    query: { edit: 'true' },
                  }"
                >
                  <v-list-item-icon class="mr-1">
                    <v-icon size="20"> mdi-pencil </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 font-weight-regular"
                      >Edit</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  id="clone-service-hours-link"
                  link
                  :to="{
                    name: 'edit-service-hour',
                    params: { id: item.id },
                    query: { clone: 'true' },
                  }"
                >
                  <v-list-item-icon class="mr-1">
                    <v-icon size="20"> mdi-file-multiple </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 font-weight-regular"
                      >Clone</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  id="delete-service-hours-link"
                  @click="
                    getRowData(item);
                    deleteDialog = true;
                  "
                >
                  <v-list-item-icon class="mr-1">
                    <v-icon size="20">delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="body-1 font-weight-regular"
                      >Delete</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </span>
      </template>
    </v-data-table>

    <!-- delete service hours --->
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card class="pa-2 py-3">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font"> Delete Service Hours </span>
        </v-card-title>
        <v-card-text class="body-2">
          Are you sure you want to delete the selected service hours?

          <div class="mt-5">
            <b class="black--text"> Warning: You cannot undo this action. </b>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false" class="font-weight-bold">
            Cancel
          </v-btn>
          <v-btn dark @click="confirmDelete()" class="font-weight-bold">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!------>
  </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle.vue";
import { $servicehours } from "@/services/Index";

export default {
  name: "service-hours-index",
  components: {
    PageTitle,
  },
  data: () => {
    return {
      breadcrumbsList: [
        {
          text: "Settings",
          disabled: false,
          path: "settings",
        },
        {
          text: "Service Hours",
          disabled: true,
          path: "",
        },
      ],
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        { text: "Time Zone", value: "timezone" },
        { text: "Associated Groups", value: "group_names" },
        {
          text: "Actions",
          value: "action",
          align: "right",
          sortable: false,
        },
      ],
      serviceHours: [],
      totalItems: 0,
      pagination: {},
      loading: false,
      deleteDialog: false,
      selectedData: null,
      globalSearchKeyword: "",
    };
  },
  watch: {
    pagination: {
      handler(newVal, oldVal) {
        /** prevent this check to invoked function on page load */
        if (oldVal.itemsPerPage) {
          this.getServiceHours();
        }
      },
      deep: true,
    },

    /*** temporary code for global search */

    $route: {
      handler: function (to, from) {
        this.globalSearchKeyword = "";
        let name = to.query.name;
        if (name) {
          this.globalSearchKeyword = name;
          this.getServiceHours();
        } else {
          this.getServiceHours();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getServiceHours();
  },
  methods: {
    /** getServiceHours data from API's */
    async getServiceHours() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      const data = {
        page,
        per_page: itemsPerPage,
        q: {
          name_cont: this.globalSearchKeyword,
          group_names_cont: this.globalSearchKeyword,
          id_in: this.globalSearchKeyword,
          m: "or",
        },
      };
      // If sorting ..
      if (sortBy && sortBy.length) {
        const dir = sortDesc.length
          ? sortDesc[0] === true
            ? "desc"
            : "asc"
          : "";
        data.q.s = `${sortBy[0]} ${dir}`;
      }
      try {
        const response = await $servicehours.fetchList(data, {});
        if (response.data) {
          this.totalItems = response.data.pagination.total_count;
          this.serviceHours = response.data.service_hours;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
      }
    },

    getRowData(item) {
      this.selectedData = item;
    },

    /** deleting selected hours API request */
    async confirmDelete() {
      let payload = {
        id: this.selectedData.id,
      };
      try {
        const response = await $servicehours.delete(payload.id, {});
        if (response.data) {
          this.deleteDialog = false;
          this.getServiceHours();
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Delete Service Hours",
              message: `Selected service hours has been deleted.`,
              type: "success",
            },
          ]);
        }
      } catch (error) {
        this.deleteDialog = false;
      }
    },
  },
};
</script>
